import withResumenCv from "../../hoc/withTrabajadores/withResumenCvl";
import ResumenCv from "../../view/components/RegistroUsuarios/PerfilProfesional/VistaPerfilProfesional/ResumenCv";

export default withResumenCv(ResumenCv)